import { v4 as uuidv4 } from "uuid";

export interface TagInterface {
  id: string;
  name: string;
  color: string;
}

class Tag implements TagInterface {
  readonly id: string;
  readonly name: string;
  readonly color: string;

  constructor(tag?: Partial<TagInterface>) {
    this.id = tag?.id || uuidv4();
    this.name = tag?.name || "";
    this.color = tag?.color || "";
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      color: this.color,
    };
  }

  static fromJSON(data: any): Tag {
    return new Tag({
      id: data.id,
      name: data.name,
      color: data.color,
    });
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): Tag {
    return new Tag({
      ...this,
      name: name,
    });
  }

  getColor(): string {
    return this.color;
  }

  setColor(color: string): Tag {
    return new Tag({
      ...this,
      color: color,
    });
  }
}

export default Tag;
